import {CreateArticleVersionDocument, CreateArticleVersionInput} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useCreateArticleVersion = () => {
  const [mutate] = useMutation(CreateArticleVersionDocument);

  return (input: CreateArticleVersionInput) => mutate({ variables: { input } });
}